import { ReactNode } from 'react';
import { FormLabel, Stack, StackProps, Typography } from '@mui/material';

type Props = {
  title: string;
  text: string | ReactNode | number | undefined | null;
} & StackProps;

export const DataEntry = ({ title, text, ...rest }: Props) => {
  return (
    <Stack {...rest}>
      <FormLabel>{title}</FormLabel>
      {typeof text === 'string' || typeof text === 'number' ? (
        <Typography whiteSpace={'break-spaces'}>{text ?? '-'}</Typography>
      ) : (
        text
      )}
    </Stack>
  );
};
